// src/constants/ConteoRegresivoConstants.js
export const conteoRegresivoConstants = {
  PRIMER_ACTIVO_REQUEST: 'PRIMER_ACTIVO_REQUEST',
  PRIMER_ACTIVO_SUCCESS: 'PRIMER_ACTIVO_SUCCESS',
  PRIMER_ACTIVO_FAILURE: 'PRIMER_ACTIVO_FAILURE'
};
  